import React, { useState, useEffect } from "react";
import {
	Table,
	Button,
	Modal,
	Form,
	Input,
	Row,
	Col,
	Space,
	Select,
	Tooltip,
	Card,
	notification,
	Badge,
} from "antd";
import { UsergroupAddOutlined, EditOutlined } from "@ant-design/icons";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import rsfNotiService from "../../services/rsfServiceNotification";
import { useMediaQuery } from "react-responsive";
import userService from "../../services/user";
import LocationComponent from "../../components/locationRsf";

const { Option } = Select;

const RSFSetting = () => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [edit, setEdit] = useState(null);
	const [form] = Form.useForm();

	const [data, setData] = useState([]);
	const [userData, setUserData] = useState({});

	const [loading, setLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [totalDataCount, setTotalDataCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(15);
	const [users, setUsers] = useState(null);
	const [approversData, setApproversData] = useState([
		{ approver: undefined, permission: 1 },
	]);
	const [nameFilter, setNameFilter] = useState('');
	const [userFilter, setUserFilter] = useState([]);

	const selectedLocations = Form.useWatch("approval_required", form) || [];

	const getUsers = async () => {
		let response;
		response = await userService.getUsers();
		setUsers(response.data);
	};

	useEffect(() => {
		getUsers();
	}, []);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setEdit(null);
		form.resetFields();
	};

	const handleEdit = (record) => {
	setEdit(record);
	setIsModalVisible(true);

	const locations = [];
	const users = [];

	record.items.forEach((item) => {
		const index = locations.indexOf(item.location_id);

		if (index === -1) {
		locations.push(item.location_id);
		users.push([item.user_id]);
		} else {
		users[index].push(item.user_id);
		}
	});

	setApproversData(locations.map(() => ({})));

	form.setFieldsValue({
		setting_name: record.setting_name,
		approval_required: locations,
		users: users,
	});
	};

	const getSettingsRsf = async (page = 1, perPage = itemsPerPage) => {
		setLoading(true);
		try {

			const response = await rsfNotiService.getSettings(page, perPage, {
			name: nameFilter,
			user_ids: userFilter,
			});

			setData(response.data);
			setCurrentPage(response.meta.current_page);
			setTotalDataCount(response.meta.total);
			setItemsPerPage(response.meta.per_page);
		} catch (error) {
			console.log(error);
			notification.error({ message: "Error fetching data" });
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getSettingsRsf();
	}, []);

	const onFinish = async (values) => {
	try {
		const payload = {
		setting_name: values.setting_name,
		data: values.approval_required.map((loc, i) => ({
			location_id: loc,
			user_ids: values.users[i],
		})),
		};

		console.log("Payload:", payload);

		if (edit) {
		await rsfNotiService.updateSetting(edit.id, payload);
		} else {
		await rsfNotiService.createSetting(payload);
		}

		notification.success({ message: "Success" });
		handleCancel();
		getSettingsRsf();

	} catch (e) {
		console.log(e);
		notification.error({ message: "Errorasd" });
	}
	};

	const columns = [
  {
    title: "Setting Name",
    dataIndex: "setting_name",
  },
  {
    title: "Details",
    render: (_, record) => {
      const grouped = {};

      record.items.forEach((item) => {
        if (!grouped[item.location_id]) {
          grouped[item.location_id] = {
            location_name: item.location_name,
            users: [],
          };
        }

        grouped[item.location_id].users.push(item.user_name);
      });

      return Object.values(grouped).map((group, i) => (
        <div key={i} style={{ marginBottom: 8 }}>
          <Badge count={`Loc: ${group.location_name}`} />
          <div style={{ marginLeft: 10 }}>
            Users: {group.users.join(", ")}
          </div>
        </div>
      ));
    },
  },
  {
    title: "Action",
    key: "action",
    width: 100,
    render: (_, record) => (
      <Tooltip title="Edit">
        <EditOutlined
          style={{ color: "#1677ff", cursor: "pointer", fontSize: 18 }}
          onClick={() => handleEdit(record)}
        />
      </Tooltip>
    ),
  },
];

	const removeApproversAndPermissions = (index) => {
		setApproversData((prevData) => prevData.filter((_, i) => i !== index));
	};

	const renderApproversAndPermissions = () => {
		return approversData.map((data, index) => (
			<div key={`approver-permission-${index}`}>
				<Card
					size='small'
					title={
						<span>
							<Badge color='#2d77fa' count={index + 1} /> For Location {index + 1}
						</span>
					}
					className='mb-10'
				>
					<Row gutter={[12, 12]}>
						

						<Col span={12}>
							<Form.Item
								name={["approval_required", index]}
								label={`Location`}
								rules={[
									{ required: true, message: "Please select a Location" },
								]}
							>
								<LocationComponent
									all={true}
									exclude={selectedLocations.filter((_, i) => i !== index)}
								/>

							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item
								name={["users", index]}
								label={`Users `}
								rules={[
									{ required: true, message: "Please select an User" },
								]}
							>
								<Select
									showSearch={true}
									optionFilterProp='children'
									style={{ width: "100%" }}
									size='large'
									mode='multiple'
									allowClear
								>
									{users &&
										users.map((user) => (
											<Select.Option key={user.id} value={user.id}>
												{user.name}
											</Select.Option>
										))}
								</Select>
							</Form.Item>
						</Col>

					</Row>
				</Card>
				{index > 0 && (
					<div className='textRight mb-10'>
						<Button
							type='dashed'
							onClick={() => removeApproversAndPermissions(index)}
						>
							Remove
						</Button>
					</div>
				)}
			</div>
		));
	};

	const handleAddApproversAndPermissions = () => {
		setApproversData((prevData) => [
			...prevData,
			{ approver: undefined, permission: 1 },
		]);
	};

	const handleAddApproversAndPermissionsForNewRecord = () => {
		setApproversData((prevData) => [{ approver: undefined, permission: 1 }]);
	};

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header
						icon={<UsergroupAddOutlined />}
						title='Notification Settings'
						right={
							<Button
								className='btn-blue'
								type='primary'
								onClick={() => {
									showModal();
									handleAddApproversAndPermissionsForNewRecord();
								}}
							>
								Add Setting
							</Button>
						}
					/>
				</Col>
			</Row>

			<Card
				title={
					<>
						Manage Notification Settings
					</>
				}
			>
				

				<Table
					style={{ minHeight: "100vh" }}
					loading={loading}
					columns={columns}
					dataSource={data.map((item, index) => ({ ...item, key: index }))}
					scroll={{
						x: 1800,
					}}
					pagination={{
						total: totalDataCount,
						current: currentPage,
						pageSize: itemsPerPage,
						onChange: (page, pageSize) => getSettingsRsf(page, pageSize),
					}}
				/>
			</Card>

			<Modal
				style={{ top: 14 }}
				title={edit ? "Edit Settings" : "Add Settings"}
				open={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				width={900}
			>
				<Form
					form={form}
					onFinish={onFinish}
					layout='vertical'
					className='mt-20'
				>
					<Form.Item
						name='setting_name'
						label='Setting Name'
						rules={[{ required: true, message: "Please enter the setting name" }]}
					>
						<Input size='large' />
					</Form.Item>

					{renderApproversAndPermissions()}

					<div
						style={{ display: "flex", justifyContent: "space-between" }}
						className='mb-20'
					>
						<Button type='dashed' onClick={handleAddApproversAndPermissions}>
							Add More
						</Button>
					</div>

					<Form.Item>
						<Button type='primary' htmlType='submit' loading={loading}>
							{edit ? "Save Changes" : "Add Group"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</DefaultLayout>
	);
};

export default RSFSetting;
